import axios from "axios";

export default async function getAllForms(projectName){
    const res = await axios.get(`/project/${projectName}/all-forms`);
    return res.data
}